export const NOTES_CONFIG = {
  customer: {
    key: "customer",
    label: "Cliente"
  },
  facility: {
    key: "facility",
    label: "Edificio"
  },
  apartment: {
    key: "apartment",
    label: "Departamento"
  },
  meter: {
    key: "meter",
    label: "Medidor"
  },
  contract: {
    key: "contract",
    label: "Contrato"
  },
  period: {
    key: "cycle",
    label: "Periodo"
  },
  quantityM3: {
    key: "m3",
    label: "Cantidad M3"
  },
  quantityLts: {
    key: "liters",
    label: "Cantidad Lts"
  },
  price: {
    key: "price",
    label: "Precio"
  },
  charge: {
    key: "total",
    label: "Nota"
  },
  paymentStatus: {
    key: "payStatus",
    label: "Estatus de pago"
  },
  owed: {
    key: "debt",
    label: "Cargo"
  },
  total: {
    key: "balance",
    label: "Saldo"
  }
};

export const NOTES_PHRASE = {
  page: {
    table: {
      title: "Vista de Recibos"
    }
  },
  modal: {
    titles: {
      edit: "Modificar Periodo de Corte",
      add: "Agregar Nuevo Periodo de Corte",
      delete: "¿Estas seguro de eliminar este periodo de corte?"
    },
    actions: {
      cancel: "Cancelar",
      add: "Agregar",
      delete: "Eliminar",
      save: "Guardar",
      send: "Enviar",
      file: "Ver PDF",
      payment: "Aplicar pago",
      reassign: "Modificar pago"
    },
    content: {
      send: "¿Estas seguro que desea enviar este recibo?",
      file: "¿Estas seguro que desea ver el archivo?",
      reassign: "¿Estas seguro que desea modificar el pago?",
      paymentLink: "¿Estas seguro que desea ver la liga de pago?",
      payment: (note) => {
        return `¿Estas seguro que desea aplicar el pago de \n${note.customer} en ${note.facility} - ${note.apartment} - ${note.meter} / ${note.cycle}?`
      }
    },
    dropdown: {
      label: "Orígenes de pago",
      noOptions: "No hay opciones disponibles",
      reassign: {
        label: "Acción"
      }
    }
  },
  search: {
    messages: {
      noStations: "No se ha seleccionado alguna planta."
    }
  },
  form: {
    dropdowns: {
      route: "Seleccione una Ruta",
      paymentCycle: "Seleccione una Periodo de Cobro",
      employee: "Seleccione un Empleado",
      status: "Seleccione un Estado"
    }
  }
};

export const NOTES_FILTERS = [
  NOTES_CONFIG.customer.key,
  NOTES_CONFIG.facility.key,
  NOTES_CONFIG.apartment.key,
  NOTES_CONFIG.meter.key,
  NOTES_CONFIG.contract.key
];
